import React, { useState, useContext } from "react";
import { Paper, Typography, TextField, Button } from "@mui/material";
import { AddCircle } from "@mui/icons-material";
import GlobalContext from "../contexts/globalcontext";

const AccountBalanceModalAdd = React.forwardRef(({ handleAddCrypto }, ref) => {
    const { setSbOpen, setSbMsg, setSbSeverity } = useContext(GlobalContext);
    const [newCrypto, setNewCrypto] = useState("");
    const [decPlace, setDecPlace] = useState(2);
    const handleSubmit = () => {
        if (newCrypto === "") {
            setSbSeverity("error");
            setSbMsg(`Please Input Crypto`);
            setSbOpen(true);
        } else {
            handleAddCrypto(newCrypto, decPlace);
        }
    };
    return (
        <>
            <Paper
                elevation={5}
                sx={{
                    width: "350px",
                    height: "150px",
                    padding: "20px",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    position: "absolute",
                }}
            >
                <Typography variant="h6">Add Crypto</Typography>
                <TextField
                    id="crypto-name"
                    label="Crypto"
                    placeholder="BTC"
                    variant="outlined"
                    required
                    value={newCrypto}
                    sx={{ width: "100px" }}
                    onChange={(e) => setNewCrypto(e.target.value.toLowerCase())}
                />
                <TextField
                    od="crypto-precision"
                    label="Dec Places"
                    value={decPlace}
                    type="number"
                    sx={{ width: "100px" }}
                    onChange={(e) => setDecPlace(e.target.value)}
                />
                <Button
                    variant="contained"
                    sx={{ marginLeft: "10px", padding: "15px" }}
                    endIcon={<AddCircle />}
                    onClick={() => handleSubmit()}
                >
                    Add
                </Button>
            </Paper>
        </>
    );
});

// export default React.forwardRef(AccountBalanceModalAdd);
export default AccountBalanceModalAdd;
